export const sidebarMenu = [
	{
		icon: <i className="icon-house" />,
		title: "Dashboards",
		content: ["HRM Dashboard"],
	},
	{
		icon: <i className="icon-user" />,
		title: "Admin Managment",
		content: ["Admins", "Roles"],
	},
	{
		icon: <i className="icon-building" />,
		title: "HRM Setup",
		content: [
			"Company",
			"Company Policy",
			"Branches",
			"Departments",
			"Designations",
			"Job Type",
			"Work Shift",
			"Assets",
		],
	},
	{
		icon: <i className="icon-hrm" />,
		title: "HRM",
		content: [
			"Employee",
			// "Employee Profile",
			"Allowances",
			"Attendance",
			"Organization",
			"Loans",
			"Leads",
			"Requests",
			"Employee leaves",
			"Holidays",
			"Notifications",
			"Time Sheet",
			"Schedule",
			"Overtime",
			"Warning",
			"Tickets List",
			"Tickets Reply",
			"Pay List",
			"Payslip",
			"Training",
			"Resignation",
			"Training",
		],
	},
	{
		icon: <i className="icon-crm" />,
		title: "CRM",
		content: ["Leads", "Deals", "CRM Setup"],
	},
	{
		icon: <i className="icon-grid" />,
		title: "Apps",
		content: [
			"Chat",
			"Email Inbox",
			"Email Read",
			"Email Compose",
			"Contacts",
			"Calendar",
			"Activities",
			"Promotion",
			"Award",
			"Meeting",
			"Transfer",
			"Termination",
			"Document",
			"Announcement",
		],
	},
	{
		icon: <i className="icon-announcement" />,
		title: "Expense",
		content: [],
	},
	{
		icon: <i className="icon-users" />,
		title: "Clients",
		content: ["Clients", "Client Details"],
	},
	{
		icon: <i className="icon-projects" />,
		title: "Projects",
		content: ["Projects", "Projects Details", "Projects Create"],
	},
	{
		icon: <i className="icon-book" />,
		title: "Invoice",
		content: [
			"Invoice Create",
			"Invoice Preview",
			"Invoice Edit",
			"Invoice List",
		],
	},
	// {
	// 	icon: <i className="icon-wallet" />,
	// 	title: "Payroll",
	// 	content: ["Pay List", "Payslip"],
	// },
	// {
	// 	icon: <i className="icon-chart-network" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-training" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-promotion" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-trophy" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-meeting" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-tickets1" />,
	// 	title: "Tickets",
	// 	content: ["Tickets List", "Tickets Reply"],
	// },
	// {
	// 	icon: <i className="icon-arrow-down-left-and-arrow-up-right-to-center" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-termination" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-document" />,
	// 	title: ,
	// 	content: [],
	// },
	// {
	// 	icon: <i className="icon-announcement" />,
	// 	title: ,
	// 	content: [],
	// },
];
